import { SimpleDefaultLoadingScreen } from "@coworker/apprestructured/src/shared/simple/SimpleLoading/SimpleDefaultLoadingScreen";
import { tokenScopes } from "@coworker/apprestructured/src/assets/auth/msalConfig";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { AuthorizedUserRoute } from "@coworker/apprestructured/src/layout/components/AuthorizedUserRoute/AuthorizedUserRoute";
import { AppProviders } from "@coworker/apprestructured/src/layout/components/AppProviders/AppProviders";

export const MsalWrapper = () => {
  const scopes = ["openid", "profile", "email"];
  const authRequest = {
    scopes: [...tokenScopes, ...scopes],
  };

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      loadingComponent={SimpleDefaultLoadingScreen}
      authenticationRequest={authRequest}
    >
      <AuthorizedUserRoute>
        <AppProviders />
      </AuthorizedUserRoute>
    </MsalAuthenticationTemplate>
  );
};
